module.exports = {"data":{"journeys":{"edges":[{"node":{"fields":{"slug":"/journeys/camino-2019/"},"frontmatter":{"title":"The Camino"}}}]}},"layoutContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/layout-index.json
// module id = 137
// module chunks = 60335399758886 114276838955818